import { ModuleFE_AdvisorSession, ModuleFE_EMInterface } from '@app/advisor-frontend';
import { Module, numberInRange, sortArray } from '@nu-art/ts-common';
import { ModuleFE_RuntimeEncounterFeed } from '../runtime/index.js';
import { ModuleFE_AdvisorAnalytics } from '../../_analytics/consts.js';
import { dispatch_onRecapFeedUpdated } from './dispatcher.js';
class ModuleFE_Recap_Class extends Module {
    feedItems;
    _recapOnScreen;
    //######################### Dispatch Listeners #########################
    __onBackgroundTasksChanged() {
        this.reportRecapViewAnalytics(true);
    }
    __onRuntimeEncounterFeedUpdated = (...params) => {
        if (!ModuleFE_AdvisorSession.lastSeenAt)
            return;
        this.calculateFeedItems();
        this.reportRecapViewAnalytics();
    };
    //######################### Internal Logic #########################
    calculateFeedItems = () => {
        const lastSeenTS = ModuleFE_AdvisorSession.lastSeenAt;
        const range = [lastSeenTS.previous, lastSeenTS.launch];
        const feedItems = ModuleFE_RuntimeEncounterFeed.cache.all().filter(item => numberInRange(item.__created, range));
        this.feedItems = sortArray(feedItems, i => i.__created, true);
        dispatch_onRecapFeedUpdated.dispatchAll();
    };
    reportRecapViewAnalytics = (reCalc = false) => {
        if (ModuleFE_AdvisorAnalytics.eventsHaveTriggered('catchupRecap_viewed'))
            return;
        const hasBGTasks = ModuleFE_EMInterface.hasBackgroundTasks();
        if (hasBGTasks || !this._recapOnScreen || !this.feedItems)
            return;
        if (reCalc)
            this.calculateFeedItems();
        ModuleFE_AdvisorAnalytics.trigger.recap.catchupRecap_viewed({ deltaCount: this.feedItems.length });
    };
    forceRecalcFeedItems = () => this.calculateFeedItems();
    //######################### Public Logic #########################
    getFeedItems = () => {
        if (!this.feedItems)
            this.calculateFeedItems();
        return [...this.feedItems];
    };
    get recapOnScreen() {
        return this._recapOnScreen;
    }
    set recapOnScreen(onScreen) {
        this._recapOnScreen = onScreen;
        this.reportRecapViewAnalytics();
    }
}
export const ModuleFE_Recap = new ModuleFE_Recap_Class();
//# sourceMappingURL=ModuleFE_Recap.js.map